/** Settings entry opens the embedded Integrations subpage without rendering its catalog here. */
import { productLanguage } from '@testfeed/product-language'
import { buildSettingsIntegrationsViewUrl } from '../../../resultsNavigation'
import type { ShopifyAppBridge } from '../../../shopifyApiFetch'
import { trackShopifyAction } from '../../../shopifyUiTracking'

export function IntegrationsSection({
  shopify,
  isTestFeedConnected: _isTestFeedConnected,
}: {
  shopify: ShopifyAppBridge
  isTestFeedConnected: boolean
}) {
  const copy = productLanguage.shopify.components.shopifySettingsContent
  return (
    <s-section heading={copy.integrationsSectionTitle}>
      <s-text color="subdued">{copy.integrationsSectionDescription}</s-text>
      <s-button
        href={buildSettingsIntegrationsViewUrl()}
        onClick={() => trackShopifyAction(shopify, 'navigate-integrations', () => undefined)}
      >
        {copy.integrationsSectionTitle}
      </s-button>
    </s-section>
  )
}
